exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2Us841zzDE7gkPiNjrKeWt {\n    padding: 8px 10px;\n}\n._6uW2CkUYKsMcQrzz6MyjT {\n    font-size: 18px;\n    margin-bottom: 10px;\n    font-weight: 600;\n}\n._36Bb0rHfpcCDch-lpWTnKM {\n    font-size: 14px;\n}\n._36Bb0rHfpcCDch-lpWTnKM ul {\n    margin: 6px 24px;\n    list-style: disc;\n}\n._36Bb0rHfpcCDch-lpWTnKM li {\n    margin: 3px 0;\n    line-height: 1.2;\n}\n", ""]);

// exports
exports.locals = {
	"container": "_2Us841zzDE7gkPiNjrKeWt",
	"title": "_6uW2CkUYKsMcQrzz6MyjT",
	"message": "_36Bb0rHfpcCDch-lpWTnKM"
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/AppNotification/AppNotification.css
// module id = 3757
// module chunks = 23